import { createRef, useState } from 'react';
import { CncEquipmentExt } from '../../../../shared/types/cncEquipmentExt.ts';
import { Input } from '../../../components/input.tsx';
import { ModalSubmitDialog } from '../../../components/modalSubmitDialog.tsx';
import { trpc } from '../../../utils/trpc/trpc.ts';


interface Props {
    equipment: CncEquipmentExt;
    onEquipmentUpdated: () => void;
    onClose: () => void;
}

export function CncCoordinatesDialog({
    equipment,
    onEquipmentUpdated,
    onClose,
}: Props) {

    const formRef = createRef<HTMLFormElement>();
    const [page, setPage] = useState<string>(equipment.page?.toString() || '');
    const [column, setColumn] = useState<string>(equipment.column?.toString() || '');
    const [row, setRow] = useState<string>(equipment.row?.toString() || '');

    const mutateCncEquipment = trpc.equipments.updateCnc.useMutation();


    function handleKeyDown(e: React.KeyboardEvent) {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }

    async function handleSubmit() {
        const isValidAuto = formRef.current?.reportValidity();
        if (!isValidAuto) {
            return;
        }

        const pageNumber = parseInt(page, 10);
        const columnNumber = parseInt(column, 10);
        const rowNumber = parseInt(row, 10);
        if (isNaN(pageNumber) || isNaN(columnNumber) || isNaN(rowNumber)) {
            alert('Please fill all fields with valid numbers');
            return;
        }

        const equipmentPatch: Pick<Required<CncEquipmentExt>, 'id' | 'page' | 'column' | 'row'> = {
            id: equipment.id,
            page: pageNumber,
            column: columnNumber,
            row: rowNumber,
        };

        try {
            await mutateCncEquipment.mutateAsync(equipmentPatch);
        } catch (error) {
            alert('Failed to save CNC equipment.');
            return;
        }

        onEquipmentUpdated();
        onClose();
    }

    return (
        <ModalSubmitDialog
            frameStyle={{ width: '360px' }}
            isOpen={true}
            isSubmitting={mutateCncEquipment.isPending}
            onCancel={onClose}
            onSubmit={handleSubmit}
        >
            <form ref={formRef} >
                <h3 style={{marginTop: '0px'}}>
                    {equipment.displayName}
                </h3>
                <div>
                    <div>Page</div>
                    <Input
                        className='dialog-form__input'
                        type='number'
                        min={1}
                        max={2}
                        value={page}
                        onChange={e => setPage(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className='dialog-form__field--with-margins' >
                    <div>Column</div>
                    <Input
                        className='dialog-form__input'
                        type='number'
                        min={1}
                        max={6}
                        value={column}
                        onChange={e => setColumn(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </div>
                <div className='dialog-form__field--with-margins' >
                    <div>Row</div>
                    <Input
                        className='dialog-form__input'
                        type='number'
                        min={1}
                        max={6}
                        value={row}
                        onChange={e => setRow(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </div>
            </form>
        </ModalSubmitDialog>
    );
}
